import React, {useState, useEffect, useRef, createElement} from 'react'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
const Uploads_URL = process.env.REACT_APP_IMG_URL

export async function resolveFileUrl(
  document: string,
  osiCode: string | number
): Promise<string> {
  if (document.startsWith('s3://')) {
    try {
      const response = await axios.post(`${API_URL}/files/signed-url`, {
        filePath: document,
      })
      return response.data?.signedUrl || document
    } catch {
      return document
    }
  }

  return `${Uploads_URL}/files/${osiCode}/${document}`
}

export function isS3Path(document: string): boolean {
  return document?.startsWith('s3://') || false
}

export function buildProfileImageUrl(
  imagePath: string | undefined | null,
  folder: string = 'Profile'
): string {
  if (!imagePath || imagePath === '' || imagePath === 'default.png') return ''
  if (imagePath.startsWith('s3://')) return ''
  return `${Uploads_URL}/${folder}/${imagePath}`
}

export async function resolveProfileImageUrl(
  imagePath: string,
  folder: string = 'Profile'
): Promise<string> {
  if (!imagePath) return ''
  if (imagePath.startsWith('s3://')) {
    try {
      const response = await axios.post(`${API_URL}/files/signed-url`, {
        filePath: imagePath,
      })
      return response.data?.signedUrl || ''
    } catch {
      return ''
    }
  }
  return `${Uploads_URL}/${folder}/${imagePath}`
}

export function useProfileImageUrl(
  imagePath: string | undefined | null,
  folder: string = 'Profile'
): string {
  const [url, setUrl] = useState<string>('')
  const lastPath = useRef<string>('')

  useEffect(() => {
    if (!imagePath || imagePath === '' || imagePath === 'default.png') {
      setUrl('')
      lastPath.current = ''
      return
    }
    if (imagePath === lastPath.current) return
    lastPath.current = imagePath

    resolveProfileImageUrl(imagePath, folder).then(setUrl)
  }, [imagePath, folder])

  return url
}

interface ProfileImgProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  imagePath: string | undefined | null
  folder?: string
}

export const ProfileImg: React.FC<ProfileImgProps> = ({imagePath, folder = 'Profile', ...rest}) => {
  const src = useProfileImageUrl(imagePath, folder)
  if (!src) return null
  return createElement('img', {...rest, src})
}
